import { v4 as uuidv4 } from "uuid";

import { 
  Character,
  CharacterCondition,
  CharacterSubscriptionHolder,
  CreatureHP,
  TrueCreatureInstance,
} from "@dndModels";


export class EncounterParticipant {
  participant_type = "";
  participant_id = "";
  owner_id = "";
  owner_name = "";
  parent_id = "";
  creature_id = "";
  participant?: Character | TrueCreatureInstance | CustomParticipant;
  child_participants: (TrueCreatureInstance | CustomParticipant)[] = []; // This is for grouping
  shown_ci_num = 0;

  initiative?: number;
  turn_order?: number;
  color = "white";
  add_time = -1;
  hide = false;
  include_in_difficulty = true;

  constructor(obj?: any) {
    if (obj) {
      this.participant_type = obj.participant_type ? obj.participant_type : "";
      this.participant_id = obj.participant_id ? obj.participant_id : "";
      this.owner_id = obj.owner_id ? obj.owner_id : "";
      // this.owner_name = obj.owner_name ? obj.owner_name : "";
      this.parent_id = obj.parent_id ? obj.parent_id : "";
      this.creature_id = obj.creature_id ? obj.creature_id : "";
      this.initiative = obj.initiative ? obj.initiative : undefined;
      this.turn_order = obj.turn_order ? obj.turn_order : undefined;
      this.child_participants = obj.child_participants ? obj.child_participants.map((o: any) => {
        if (this.participant_type === "Creature") {
          return new TrueCreatureInstance(o);
        } else if (this.participant_type === "Custom") {
          return new CustomParticipant(o);
        }
        return null;
      }) : [];
      if (!obj.child_participants && obj.creature_instances) {
        this.child_participants = obj.creature_instances.map((o: any) => new TrueCreatureInstance(o));
      }
      this.participant = this.child_participants.length > 0 ? this.child_participants[0] : (obj.creature_instance ? new TrueCreatureInstance(obj.creature_instance) : (obj.custom_participant ? new CustomParticipant(obj.custom_participant) : undefined));
      if (this.participant instanceof TrueCreatureInstance && this.child_participants.length === 0) {
        this.child_participants.push(this.participant.clone());
      }
      if (this.child_participants.length > 0 && this.child_participants[0] instanceof TrueCreatureInstance && this.child_participants[0].creature_id === "") {
        for (const ci of this.child_participants) {
          if (ci instanceof TrueCreatureInstance) {
            // ci.creature_id = this.creature_id;
          }
        }
      }
      if (this.participant_type === "Custom") {
        console.log(this);
        console.log(obj);
      }
      this.color = obj.color ? obj.color : "white";
      this.add_time = obj.add_time ? obj.add_time : -1;
      this.hide = obj.hide ? obj.hide : false;
      this.include_in_difficulty = obj.include_in_difficulty !== undefined ? obj.include_in_difficulty : true;
      this._name = obj._name ? obj._name : "";
    }
  }

  _name = "";
  get name(): string {
    if (this.participant) {
      if (this._name === "") {
        if (this.participant instanceof TrueCreatureInstance) {
          if (this.child_participants.length !== 1) {
            return `${this.participant.name} x ${this.child_participants.length}`;
          }
          return this.participant.name;
        }
        return this.participant.name;
      } else {
        return this._name;
      }
    }
    return "Loading";
  }

  get initiative_modifier(): number {
    return this.participant ? this.participant.initiative_modifier : 0;
  }

  get initiative_adv(): number {
    if (this.participant instanceof Character) {
      const adv_finder = this.participant.advantages.filter(o => o.advantage.type === "Initiative");
      let adv = 0;
      for (const advantage of adv_finder) {
        if (advantage.advantage.disadvantage) {
          adv--;
        } else {
          adv++;
        }
      }
      if (adv > 0) {
        return 1;
      } else if (adv < 0) {
        return -1;
      }
    }
    return 0;
  }

  get ac(): number {
    return this.participant ? this.participant.use_ac : -1;
  }

  get hp() {
    return this.participant ? this.participant.hp : new CreatureHP();
  }

  get subscription_holder() {
    if (this.participant) {
      return this.participant.subscription_holder;
    }
    return new CharacterSubscriptionHolder();
  }

  toDBObj(): any {
    return {
      participant_type: this.participant_type,
      participant_id: this.participant_id,
      owner_id: this.owner_id,
      parent_id: this.parent_id,
      creature_id: this.creature_id,
      initiative: this.initiative,
      turn_order: this.turn_order,
      color: this.color,
      add_time: this.add_time,
      hide: this.hide,
      include_in_difficulty: this.include_in_difficulty,
      child_participants: this.child_participants.map(o => o.toDBObj()),
      custom_participant: this.participant instanceof CustomParticipant ? this.participant.toDBObj() : undefined,
      _name: this._name
    };
  }

  clone(): EncounterParticipant {
    const clone = new EncounterParticipant();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: EncounterParticipant, drop_ids = false): void {
    this.participant_type = copyMe.participant_type;
    this.participant_id = copyMe.participant_id;
    this.owner_id = copyMe.owner_id;
    this.owner_name = copyMe.owner_name;
    this.parent_id = copyMe.parent_id;
    this.creature_id = copyMe.creature_id;
    this.participant = copyMe.participant; // ? (copyMe.participant instanceof Character ? copyMe.participant : copyMe.participant.clone()) : undefined;
    this.child_participants = copyMe.child_participants.map(o => o.clone(drop_ids));
    this.initiative = copyMe.initiative;
    this.turn_order = copyMe.turn_order;
    this.color = copyMe.color;
    this.add_time = copyMe.add_time;
    this.hide = copyMe.hide;
    this.include_in_difficulty = copyMe.include_in_difficulty;
    this._name = copyMe._name;
  }
}

export class CustomParticipant {
  true_id = "";
  name = "";
  description = "";
  subscription_holder: CharacterSubscriptionHolder = new CharacterSubscriptionHolder();
  changed() {
    this.subscription_holder.characterChanged();
  }
  armor_class = 0;
  get use_ac() {
    return this.armor_class;
  }
  initiative_modifier = 0;
  challenge_rating = 0;
  get use_name() {
    return this.name;
  }

  // max_hit_points: number = 0;
  // current_hit_points: number = 0;
  // temp_hit_points: number = 0;
  // override_max_hit_points: number = -1;
  // max_hit_points_modifier: number = 0;
  hp: CreatureHP = new CreatureHP();
  
  favorite_conditions: string[] = [];
  // condition_hash: { [id: string]: { level: number, source_true_id: string } } = {};
  condition_immunities: string[] = [];
  conditions: CharacterCondition[] = [];

  get condition_hash() {
    const hash:{ [id: string]: { level: number, source_true_id: string } } = {};
    for (const cc of this.conditions) {
      hash[cc.source_id] = { level: cc.level, source_true_id: cc.condition_source_true_id };
    }
    return hash;
  }

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.name = obj.name ? obj.name : "";
      this.description = obj.description ? obj.description : "";

      // this.max_hit_points = obj.max_hit_points ? obj.max_hit_points : 0;
      // this.current_hit_points = obj.current_hit_points ? obj.current_hit_points : 0;
      // this.temp_hit_points = obj.temp_hit_points ? obj.temp_hit_points : 0;
      this.hp = obj.hp ? new CreatureHP(obj.hp) : new CreatureHP();
      if (obj.current_hit_points) {
        this.hp.current = obj.current_hit_points;
      }
      if (obj.temp_hit_points) {
        this.hp.temp = obj.temp_hit_points;
      }
      if (obj.max_hit_points) {
        this.hp.max = obj.max_hit_points;
      }
      if (obj.override_max_hit_points) {
        this.hp.override_max = obj.override_max_hit_points;
      }
      if (obj.max_hit_points_modifier) {
        this.hp.max_modifier = obj.max_hit_points_modifier;
      }
      if (obj.allow_negative === undefined) {
        this.hp.allow_negative = false;
      }

      this.armor_class = obj.armor_class ? obj.armor_class : 0;
      this.initiative_modifier = obj.initiative_modifier ? obj.initiative_modifier : 0;
      this.challenge_rating = obj.challenge_rating ? obj.challenge_rating : 0;
      
      this.favorite_conditions = obj.favorite_conditions ? obj.favorite_conditions : [];
      // this.condition_hash = {};
      // if (obj.condition_hash) {
      //   const cond_ids = Object.keys(obj.condition_hash);
      //   for (const cond_id of cond_ids) {
      //     if (typeof obj.condition_hash[cond_id] === "object") {
      //       this.condition_hash[cond_id] = obj.condition_hash[cond_id];
      //     } else {
      //       this.condition_hash[cond_id] = { level: obj.condition_hash[cond_id], source_true_id: "" };
      //     }
      //   }
      // }
      this.conditions = [];
      if (obj && obj.conditions) {
        for (let i = 0; i < obj.conditions.length; i++) {
          const cc = new CharacterCondition(obj.conditions[i]);
          this.conditions.push(cc);
        }
      }
      this.condition_immunities = obj.condition_immunities ? obj.condition_immunities : [];
    }
  }

  get true_max_hit_points() {
    return this.hp.true_max;
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      name: this.name,
      description: this.description,
      // max_hit_points: this.max_hit_points,
      // current_hit_points: this.current_hit_points,
      // temp_hit_points: this.temp_hit_points,
      hp: this.hp.toDBObj(),
      armor_class: this.armor_class,
      initiative_modifier: this.initiative_modifier,
      challenge_rating: this.challenge_rating,
      favorite_conditions: this.favorite_conditions,
      // condition_hash: this.condition_hash,
      conditions: this.conditions.map(o => o.toDBObj()),
      condition_immunities: this.condition_immunities,
    };
  }

  clone(): CustomParticipant {
    const clone = new CustomParticipant();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CustomParticipant): void {
    this.name = copyMe.name;
    this.description = copyMe.description;

    // this.max_hit_points = copyMe.max_hit_points;
    // this.current_hit_points = copyMe.current_hit_points;
    // this.temp_hit_points = copyMe.temp_hit_points;
    this.hp = copyMe.hp.clone();

    this.armor_class = copyMe.armor_class;
    this.initiative_modifier = copyMe.initiative_modifier;
    this.challenge_rating = copyMe.challenge_rating;
    this.favorite_conditions = [...copyMe.favorite_conditions];
    // this.condition_hash = {...copyMe.condition_hash};
    this.conditions = copyMe.conditions.map(o => o.clone());
    this.condition_immunities = [...copyMe.condition_immunities];
  }
}
